import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { actions as authActions } from '../../../actions/authActions';
import routePaths from '../../../routePaths';
import SignInForm from './SignInForm';
import AnonymousContentPanel from '../AnonymousContentPanel';
import './SignInPageStyles.scss';
import { Button, Grid, Typography } from '@material-ui/core';

class SignInPage extends React.Component {
  componentDidMount() {
    if (this.props.token) this.props.authActions.activateAccount({ activationToken: this.props.token });
  }

  render() {
    const { authActions, returnTo } = this.props;
    return (
      <div style={{ display: 'flex', justifyContent: 'center'}}>
        {this.props.wkEnabled ?
          <AnonymousContentPanel>
            <Grid container spacing={10} style={{ width: 800 }}>
              <Grid item xs={12} md={6}>
                <Typography variant="overline" component="p" style={{ fontWeight: 600, marginBottom: 16 }}>Zaloguj się przez login i hasło</Typography>
                <SignInForm onSubmit={data => authActions.signIn(data, returnTo)} />
                <div className="password-recovery-link">
                  <div><Link to={routePaths.registration}>Utwórz nowe konto</Link></div>
                  <div><Link to={routePaths.passwordRecovery}>Zapomniałem hasła</Link></div>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="overline" component="p" style={{ fontWeight: 600, marginBottom: 16 }}>Zaloguj się przez login.gov.pl</Typography>
                <Button variant="contained" color="primary" onClick={() => authActions.wkSignIn()}>Logowanie</Button>
              </Grid>
            </Grid>
          </AnonymousContentPanel>
          : <AnonymousContentPanel style={{ maxWidth: 400, width: '100%' }}>
          <SignInForm onSubmit={data => authActions.signIn(data, returnTo)} />
          <div className="password-recovery-link">
            <div><Link to={routePaths.registration}>Utwórz nowe konto</Link></div>
            <div><Link to={routePaths.passwordRecovery}>Zapomniałem hasła</Link></div>
          </div>
        </AnonymousContentPanel>}
      </div>
    );
  }
}

SignInPage.propTypes = {
  authActions: PropTypes.object.isRequired,
  returnTo: PropTypes.string,
  token: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return {
    authActions: bindActionCreators(authActions, dispatch),
  };
}

function mapStateToProps(_, ownProps) {
  const parsed = queryString.parse(ownProps.location.search);
  
  return {
    returnTo: parsed.returnTo,
    token: parsed.token,
    wkEnabled: parsed.wk ? true : false,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInPage);



// WEBPACK FOOTER //
// ./src/components/auth/signIn/SignInPage.js